// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-btn-close[data-v-ced45e08] {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  height: 20px;\n  width: 20px;\n}\n.c-btn-close i[data-v-ced45e08]:hover {\n  transform: scale(1.25);\n}\n.c-cta[data-v-ced45e08] {\n  cursor: pointer;\n}\n.c-image[data-v-ced45e08] {\n  background-color: var(--v-background-base);\n  width: 100%;\n  height: auto;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
